import React from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
import { TextField } from '@mui/material';


// Distributor view page  component


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};

export default class KnowledgeBankView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            noOfParams: [],
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            Title: this.props.siCurrentData.title,
            PDF: this.props.siCurrentData.pdf,
            Description: this.props.siCurrentData.description,
            errorMessage: [],

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {

        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);

        })
    }



    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event
        });
    };

    render() {
        return (
            <React.Fragment>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>VIEW KNOWLEDGE BANK</h3>
                    <div className="row">
                        <div className="col-6 mx-0 px-0 disableEvent">
                            <TextField
                                label="Knowledge Bank Title"
                                variant="standard"
                                fullWidth
                                value={this.state.Title}
                                placeholder="Knowledge Bank Title: Abc PVT. LTD."
                                //   disabled
                                sx={{ mt: '3.5%' }}
                            />

                        </div>
                        <div className="col-6  disableEvent"
                        //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
                        >
                            <TextField
                                label="PDF File"
                                variant="standard"
                                fullWidth
                                value={this.state.PDF.split("/").pop().split("_")[0] || ''}
                                placeholder="PDF File"
                                //   disabled
                                sx={{ mt: '3.5%' }}
                            />

                        </div>



                        <div className="col-6 mx-0 px-0 disableEvent">
                            <TextField
                                label="Description"
                                variant="standard"
                                fullWidth
                                value={this.state.Description || ''}
                                placeholder="Description"
                                //   disabled
                                multiline
                                sx={{ mt: '3.5%' }}
                            />

                        </div>

                    </div>

                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
